import { ValidateStatus } from 'antd/lib/form/FormItem'
import KAddressInput from 'app/components/Modules/Form/KAddressInput'
import { useKFormContext } from 'app/lib/contexts/KFormContext'
import { useForceUpdate } from 'app/lib/hooks/useForceUpdate'
import { ComponentProps, useState } from 'react'

type Props = {
  initialDeliveryZip: string
}

type HookReturnType = {
  zipHasChanged: boolean
  inputProps: Partial<ComponentProps<typeof KAddressInput>['inputProps']>
}

export default function ({ initialDeliveryZip }: Props): HookReturnType {
  const { form, initialValues } = useKFormContext()
  const forceUpdate = useForceUpdate()

  const [zipHasChanged, setZipHasChanged] = useState(
    initialDeliveryZip !== initialValues.deliveryZip
  )

  const validateZip = async (_rule: unknown, value: string) => {
    forceUpdate()
    setZipHasChanged(value !== initialDeliveryZip)
    return Promise.resolve()
  }

  const zipStatus: ValidateStatus =
    zipHasChanged && form.getFieldValue('deliveryZip') ? 'warning' : undefined

  const cityStatus: ValidateStatus =
    zipHasChanged && form.getFieldValue('deliveryCity') ? 'warning' : undefined

  return {
    zipHasChanged,
    inputProps: {
      zip: {
        validateStatus: zipStatus,
        rules: [{ validator: validateZip }]
      },
      city: {
        validateStatus: cityStatus,
        onChange: forceUpdate
      }
    }
  }
}
